import { limitOrderAddress } from '../constants/addresses.js';
import { ContextHost } from '../service/contextHost.js';
import {} from '../types/token.js';
import { http } from '../utils/request/index.js';
import { httpServiceHost } from './../serviceHost.js';
import {} from './type.js';
import { bytesToBigInt, hashTypedData, } from 'viem';
export class LimitOrder extends ContextHost {
    constructor(config, injected) {
        super({ env: config.env, chainId: config.chainId }, {
            publicClient: injected.publicClient,
            walletClient: injected.walletClient,
        });
    }
    get712Domain = () => {
        return {
            name: 'Tokenlon',
            version: 'v5',
            chainId: this.chainId,
            verifyingContract: limitOrderAddress[this.chainId],
        };
    };
    get712Types = () => {
        return {
            Order: [
                { name: 'makerToken', type: 'address' },
                { name: 'takerToken', type: 'address' },
                { name: 'makerTokenAmount', type: 'uint256' },
                { name: 'takerTokenAmount', type: 'uint256' },
                { name: 'maker', type: 'address' },
                { name: 'taker', type: 'address' },
                { name: 'salt', type: 'uint256' },
                { name: 'expiry', type: 'uint64' },
            ],
        };
    };
    generatePseudoRandomSalt = () => {
        const salt = crypto.getRandomValues(new Uint8Array(32));
        return bytesToBigInt(salt).toString();
    };
    getLimitOrderHash(order) {
        const domain = this.get712Domain();
        const types = this.get712Types();
        const primaryType = 'Order';
        const message = {
            makerToken: order.makerToken,
            takerToken: order.takerToken,
            makerTokenAmount: order.makerTokenAmount,
            takerTokenAmount: order.takerTokenAmount,
            maker: order.maker,
            taker: order.taker,
            salt: order.salt,
            expiry: order.expiry,
        };
        return hashTypedData({ domain, types, primaryType, message });
    }
    async getMakerSignature(order, account) {
        const domain = this.get712Domain();
        const types = this.get712Types();
        const primaryType = 'Order';
        const walletClient = this.useWalletClient();
        const signatureTypedData = await walletClient.signTypedData({
            account,
            domain,
            types,
            primaryType,
            message: order,
        });
        const paddedNonce = '00'.repeat(32);
        const composedSig = `${signatureTypedData}${paddedNonce}02`;
        return composedSig;
    }
    getTokenList = async (chainId) => {
        if (!chainId)
            chainId = this.chainId;
        const tokenlist = await http(`${this.host(httpServiceHost)}/v5/limit-order/tokenlist?chainId=${chainId}`);
        return tokenlist;
    };
    signLimitOrder = async (limitOrderRequest) => {
        const walletClient = this.useWalletClient();
        const [account] = await walletClient.getAddresses();
        limitOrderRequest.salt =
            limitOrderRequest.salt ?? this.generatePseudoRandomSalt();
        const orderHash = this.getLimitOrderHash(limitOrderRequest);
        const makerSig = await this.getMakerSignature(limitOrderRequest, account);
        const limitOrder = {
            ...limitOrderRequest,
            chainId: this.chainId,
            orderHash: orderHash,
            makerSig: makerSig,
            status: 'Pending',
        };
        return limitOrder;
    };
    signCancelLimitOrder = async (limitOrderHashes) => {
        const walletClient = this.useWalletClient();
        const [account] = await walletClient.getAddresses();
        const message = limitOrderHashes.join(',');
        const sig = await walletClient.signMessage({
            account: account,
            message,
        });
        return sig;
    };
    createLimitOrder = async (limitOrder) => {
        const result = await http(`${this.host(httpServiceHost)}/v5/limit-order/limitorder`, {
            body: limitOrder,
            fetchOptions: {
                method: 'POST',
            },
        });
        return result;
    };
    cancelLimitOrder = async (cancelLimitOrderRequest) => {
        const result = await http(`${this.host(httpServiceHost)}/v5/limit-order/limitorder`, {
            body: cancelLimitOrderRequest,
            fetchOptions: {
                method: 'PUT',
            },
        });
        return result;
    };
}
//# sourceMappingURL=index.js.map